module.exports = __webpack_public_path__ + "static/media/Error.b06c02ba.svg";